import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import PortfolioPage from "@/pages/PortfolioPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { BlogIndex, BlogDetail } from "@/pages/BlogPages";

// Hoisted to module scope so it isn't recreated on every render.
const TOASTER_OPTIONS = {
  style: {
    background: "#0A0A0A",
    border: "1px solid rgba(212,175,55,0.3)",
    color: "#F5EFE0",
    fontFamily: "'Outfit', sans-serif",
  },
};

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-right" theme="dark" toastOptions={TOASTER_OPTIONS} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
